import { useSelector } from 'react-redux';
import appConfigSelectors from 'modules/appConfig/selectors';

export default function useScheduledCancellationFlag() {
	const config = useSelector(appConfigSelectors.getAppConfig);
	const { featureFlags } = config || {};
	return featureFlags.scheduledCancellationFlow;
}
